import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot,  NavigationExtras,  Route } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';



@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private authService: AuthenticationService, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

      let now = new Date();
      let tokenExp = new Date(Number(localStorage.getItem('tokenExp')) * 1000);
        if (localStorage.getItem('token') &&  tokenExp > now) {
          console.log('route.data.roles = ' + route.data.roles);
          if(route.data.roles){
            return this.authService.hasPermission(route.data.roles);
          } else {
            return true;
          }
        }
        this.router.navigate(['/login']);
        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

      canLoad(route: Route): boolean {
        let url = `/${route.path}`;
        return this.checkLogin(url);
      }
    
      checkLogin(url: string): boolean {
        if (localStorage.getItem('token')) { return true; }
    
        // Store the attempted URL for redirecting
        //this.authService.redirectUrl = url;
    
        // Create a dummy session id
        let sessionId = 123456789;
    
        // Set our navigation extras object
        // that contains our global query params and fragment
        let navigationExtras: NavigationExtras = {
          queryParams: { 'session_id': sessionId },
          fragment: 'anchor'
        };
    
        // Navigate to the login page with extras
        this.router.navigate(['/login'], navigationExtras);
        return false;
      }
}
